import { AxiosInstance } from "axios";
import { IUser } from "src/views/Admin/Users/types";
import { insertId } from "../../insertId";

export default (api: AxiosInstance, url: string) => async (user: IUser) => {
  const urlWithId = insertId(url, user.id);
  const response = await api.delete(urlWithId);
  return response.data;
};



// WEBPACK FOOTER //
// ./src/services/api/admin/users/delete.ts